import { render, staticRenderFns } from "./OrderDocuments.vue?vue&type=template&id=5a073a1c&"
import script from "./OrderDocuments.vue?vue&type=script&lang=ts&"
export * from "./OrderDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports